import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IDebtor, IDebtorDto } from '../../interfaces/debtor';

@Injectable({
  providedIn: 'root',
})
export class DebtorService {
  private readonly basePath = ':API_BASE_URLsales/remittances/debtors';

  constructor(private http: HttpClient) {}

  getByClientId(clientId: string): Observable<IDebtor> {
    const params = new HttpParams().set('clientId', clientId);
    return this.http.get<IDebtor>(this.basePath, { params });
  }

  create(data: IDebtorDto): Observable<IDebtor> {
    return this.http.post<IDebtor>(this.basePath, data);
  }

  update(id: string, data: IDebtorDto): Observable<IDebtor> {
    return this.http.patch<IDebtor>(`${this.basePath}/${id}`, data);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }
}
